import { useCallback, useRef } from 'react';
import useTracking from './use-tracking';

export default function useAssignmentFlowTracking(type) {
  const {
    trackAssignmentFlowStarted,
    trackAssignmentConfirmed
  } = useTracking();
  const startedAtRef = useRef(null);

  const start = useCallback(
    (details) => {
      startedAtRef.current = Date.now();
      trackAssignmentFlowStarted({ type, ...details });
    },
    [trackAssignmentFlowStarted, type]
  );

  const durationMs = () =>
    startedAtRef.current === null ? 0 : Date.now() - startedAtRef.current;

  const confirm = useCallback(
    (details) => {
      trackAssignmentConfirmed({ type, ...details, durationMs: durationMs() });
    },
    [trackAssignmentConfirmed, type]
  );

  return { start, confirm };
}



// WEBPACK FOOTER //
// ./analytics/use-assignment-flow-tracking.js